import Alert from "../../components/alert";

type UnderwritingUiFrameProps = {
  title: string;
  embedUrl: string;
  isLoading: boolean;
  error: string;
  loadingText: string;
};

export default function UnderwritingUiFrame({
  title,
  embedUrl,
  isLoading,
  error,
  loadingText,
}: UnderwritingUiFrameProps) {
  return (
    <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      {isLoading ? (
        <div style={{ flex: 1, minHeight: 0, padding: 16 }}>{loadingText}</div>
      ) : error ? (
        <div className="p-3" style={{ flex: 1, minHeight: 0 }}>
          <Alert type="danger" message={error} />
        </div>
      ) : (
        <iframe
          title={title}
          src={embedUrl}
          sandbox="allow-same-origin allow-scripts allow-forms"
          allow="clipboard-write"
          referrerPolicy="no-referrer"
          style={{ flex: 1, width: "100%", minHeight: 0, border: 0, display: "block" }}
        />
      )}
    </div>
  );
}
